/**
 * Flexportal API
 *   <h3>Support</h3>    <p>Welcome to the Flexportal API! We invite you to explore these endpoints and   integrate the Flexportal with any other software systems you use. This documentation will guide you   throughout your journey.</p> <p>If you would like our assistance, know that we’re always here to  help. We’re happy to offer consultancy or development services. For more information, feel free to  call us at 085 - 401 6371 or email us at <a href=\'mailto:servicedesk@flexportal.nl\'>  servicedesk@flexportal.nl</a>.</p>     <h3>Requesting custom endpoints</h3>    <p>At Flexportal, we understand that every organization has unique integration needs. If you   require endpoints beyond our standard offering, we invite you to request custom endpoints. We’ll   work with you to define your requirements and develop the functionality needed to best suit your   use case.</p>    <p>Please feel free to reach out by phone at 085 - 401 6371 or by email at   <a href=\'mailto:servicedesk@flexportal.nl\'>servicedesk@flexportal.nl</a> to explore the   possibilities.</p>    <h3>Beta and stable versions</h3>     <p>Many endpoints are labeled as <strong>beta</strong>. While this means that breaking changes can   occur without notice, it also enables us to refine and enhance these endpoints more freely. We also   offer endpoints with a <strong>stable</strong> label, which guarantees no breaking changes will  take place unless all involved parties agree.</p>     <p>If you rely on certain endpoints for important workflows, we highly recommend requesting an   upgrade from beta to stable to avoid any unintended complications. We’ll perform a thorough review,  ensure everything adheres to our conventions, and then apply the stable label.</p>     <h3>Authorization</h3>     <p>Most API endpoints require authorization. Simply add an authorization header with a valid JWT   token to every request:</p>     <p><code>Authorization: Bearer [JWT Token goes here]</code></p>     <p>Obtain the token from the <strong>/api/Authentication/UsernameAuthenticate</strong> endpoint.   This call needs the email address/username and password of a Flexportal user.</p>     <p>Many endpoints are tied to a specific user, especially those for flexworkers and contact   persons. Some, however, have a more general purpose and typically require an employee’s JWT token.  </p>     <p>If you need to call employee endpoints, you may choose to create a dedicated Flexportal user for   API calls. Create the user, set a password as usual, and you can initially use your own email   address to set that password before changing it later.</p>    <h3>Conventions</h3>    <p>We work to keep our endpoints clear and consistent. To achieve this, we follow these guidelines:  </p>    <ul>      <li>No hyphens, dashes, or underscores</li>       <li>Use camelCase</li>       <li>Be explicit: <strong>flexworkerId</strong> or <strong>flexworkerNumber</strong> is clearer           than a generic <strong>Id</strong> or <strong>Number</strong></li>   </ul>     <p>We welcome your feedback. Let us know if you find an endpoint that doesn’t follow these   conventions.</p>                
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';


// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class TenantsApiService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * BETA
     * &lt;h3&gt;Version&lt;/h3&gt;&lt;p&gt;&lt;code&gt;BETA&lt;/code&gt; Breaking changes may occur without notice&lt;/p&gt;&lt;br/&gt;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTenantsInvalidateTenantsPost(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public apiTenantsInvalidateTenantsPost(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public apiTenantsInvalidateTenantsPost(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public apiTenantsInvalidateTenantsPost(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/api/tenants/invalidateTenants`,
            null,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
